/* eslint-disable */
const urls = {"index":{"route":"/","args":{}},"account_login":{"route":"/accounts/login/","args":{}},"account_logout":{"route":"/accounts/logout/","args":{}},"account_inactive":{"route":"/accounts/inactive/","args":{}},"account_signup":{"route":"/accounts/signup/","args":{}},"account_reauthenticate":{"route":"/accounts/reauthenticate/","args":{}},"account_email":{"route":"/accounts/email/","args":{}},"account_email_verification_sent":{"route":"/accounts/confirm-email/","args":{}},"account_change_password":{"route":"/accounts/password/change/","args":{}},"account_set_password":{"route":"/accounts/password/set/","args":{}},"account_reset_password":{"route":"/accounts/password/reset/","args":{}},"account_confirm_login_code":{"route":"/accounts/login/code/confirm/","args":{}},"account_reset_password_from_key_done":{"route":"/accounts/password/reset/key/done/","args":{}},"account_reset_password_done":{"route":"/accounts/password/reset/done/","args":{}},"socialaccount_login_cancelled":{"route":"/accounts/3rdparty/login/cancelled/","args":{}},"socialaccount_login_error":{"route":"/accounts/3rdparty/login/error/","args":{}},"socialaccount_signup":{"route":"/accounts/3rdparty/signup/","args":{}},"socialaccount_connections":{"route":"/accounts/3rdparty/","args":{}},"discord_login":{"route":"/accounts/discord/login/","args":{}},"discord_callback":{"route":"/accounts/discord/login/callback/","args":{}},"class_tracker:index":{"route":"/class_tracker/","args":{}},"class_tracker:login_view":{"route":"/class_tracker/login_view/","args":{}},"class_tracker:logout_view":{"route":"/class_tracker/logout_view/","args":{}},"class_tracker:manage_course_list":{"route":"/class_tracker/manage_course_list/","args":{}},"class_tracker:add_classes":{"route":"/class_tracker/add_classes/","args":{}},"class_tracker:view_class_alerts":{"route":"/class_tracker/class_alerts/","args":{}},"class_tracker:get_schools":{"route":"/class_tracker/get_schools/","args":{}},"class_tracker:get_subjects":{"route":"/class_tracker/get_subjects/<int:school_id>/<int:term_id>/","args":{"school_id":"number","term_id":"number"}},"class_tracker:get_course_sections":{"route":"/class_tracker/get_course_sections/<int:term_id>/<int:subject_id>/","args":{"term_id":"number","subject_id":"number"}},"class_tracker:refresh_available_terms":{"route":"/class_tracker/refresh_available_terms/","args":{}},"class_tracker:refresh_semester_data":{"route":"/class_tracker/refresh_semester_data/<int:school_id>/<int:term_id>/","args":{"school_id":"number","term_id":"number"}},"class_tracker:fetch_new_semester_course_sections":{"route":"/class_tracker/fetch_new_semester_course_sections/<int:school_id>/<int:term_id>/<int:subject_id>/","args":{"school_id":"number","term_id":"number","subject_id":"number"}},"class_tracker:get_recipient_form":{"route":"/class_tracker/get_recipient_form/<int:recipient_id>/","args":{"recipient_id":"number"}},"class_tracker:update_recipient":{"route":"/class_tracker/add_recipient/<int:recipient_id>/","args":{"recipient_id":"number"}},"class_tracker:add_watched_section":{"route":"/class_tracker/add_watched_section/<int:recipient_id>/<int:section_id>/","args":{"recipient_id":"number","section_id":"number"}},"class_tracker:remove_watched_section":{"route":"/class_tracker/remove_watched_section/<int:recipient_id>/<int:section_id>/","args":{"recipient_id":"number","section_id":"number"}},"queues_home":{"route":"/scheduler/queues/","args":{}},"queues_home_json":{"route":"/scheduler/queues/stats.json","args":{}},"queue_workers":{"route":"/scheduler/queues/<str:queue_name>/workers/","args":{"queue_name":"string"}},"queue_registry_jobs":{"route":"/scheduler/queues/<str:queue_name>/<str:registry_name>/jobs","args":{"queue_name":"string","registry_name":"string"}},"queue_registry_action":{"route":"/scheduler/queues/<str:queue_name>/<str:registry_name>/<str:action>/","args":{"queue_name":"string","registry_name":"string","action":"string"}},"queue_confirm_job_action":{"route":"/scheduler/queues/<str:queue_name>/confirm-action/","args":{"queue_name":"string"}},"queue_job_actions":{"route":"/scheduler/queues/<str:queue_name>/actions/","args":{"queue_name":"string"}},"workers_home":{"route":"/scheduler/workers/","args":{}},"worker_details":{"route":"/scheduler/workers/<str:name>/","args":{"name":"string"}},"job_details":{"route":"/scheduler/jobs/<str:job_name>/","args":{"job_name":"string"}},"job_detail_action":{"route":"/scheduler/jobs/<str:job_name>/<str:action>/","args":{"job_name":"string","action":"string"}},"discord_tracker:login":{"route":"/classcords/login/","args":{}},"discord_tracker:login_success":{"route":"/classcords/login-success/","args":{}},"discord_tracker:profile":{"route":"/classcords/profile/","args":{}},"discord_tracker:welcome":{"route":"/classcords/","args":{}},"discord_tracker:explore_all_listings":{"route":"/classcords/all/","args":{}},"discord_tracker:unapproved_invites":{"route":"/classcords/unapproved-invites/","args":{}},"discord_tracker:referral_management":{"route":"/classcords/referrals/","args":{}},"discord_tracker:referral_redeem":{"route":"/classcords/referral/<str:referral_code>/","args":{"referral_code":"string"}},"discord_tracker:select_school":{"route":"/classcords/ajax/select-school/","args":{}},"discord_tracker:server_invites":{"route":"/classcords/ajax/servers/<int:server_id>/invites/","args":{"server_id":"number"}},"discord_tracker:validate_discord_invite":{"route":"/classcords/ajax/validate-discord-invite/","args":{}},"discord_tracker:submit_invite":{"route":"/classcords/ajax/submit-invite/","args":{}},"discord_tracker:get_subjects":{"route":"/classcords/ajax/schools/<int:school_id>/subjects/","args":{"school_id":"number"}},"discord_tracker:get_courses":{"route":"/classcords/ajax/schools/<int:school_id>/subjects/<int:subject_id>/courses/","args":{"school_id":"number","subject_id":"number"}},"discord_tracker:get_instructors":{"route":"/classcords/ajax/schools/<int:school_id>/subjects/<int:subject_id>/instructors/","args":{"school_id":"number","subject_id":"number"}},"discord_tracker:track_invite_usage":{"route":"/classcords/ajax/invites/<int:invite_id>/track-usage/","args":{"invite_id":"number"}},"discord_tracker:approve_invite":{"route":"/classcords/ajax/invites/<int:invite_id>/approve/","args":{"invite_id":"number"}},"discord_tracker:reject_invite":{"route":"/classcords/ajax/invites/<int:invite_id>/reject/","args":{"invite_id":"number"}},"discord_tracker:get_all_subjects":{"route":"/classcords/ajax/subjects/","args":{}},"discord_tracker:get_all_courses":{"route":"/classcords/ajax/subjects/<int:subject_id>/courses/","args":{"subject_id":"number"}},"__reactivated_do_not_use":{"route":"__reactivated_do_not_use","args":{}},"__reactivated_do_not_use_args":{"route":"__reactivated_do_not_use_args","args":{"_":"string"}}};

interface URLMap {
    index: index;
    account_login: account_login;
    account_logout: account_logout;
    account_inactive: account_inactive;
    account_signup: account_signup;
    account_reauthenticate: account_reauthenticate;
    account_email: account_email;
    account_email_verification_sent: account_email_verification_sent;
    account_change_password: account_change_password;
    account_set_password: account_set_password;
    account_reset_password: account_reset_password;
    account_confirm_login_code: account_confirm_login_code;
    account_reset_password_from_key_done: account_reset_password_from_key_done;
    account_reset_password_done: account_reset_password_done;
    socialaccount_login_cancelled: socialaccount_login_cancelled;
    socialaccount_login_error: socialaccount_login_error;
    socialaccount_signup: socialaccount_signup;
    socialaccount_connections: socialaccount_connections;
    discord_login: discord_login;
    discord_callback: discord_callback;
    class_tracker_index: class_tracker_index;
    class_tracker_login_view: class_tracker_login_view;
    class_tracker_logout_view: class_tracker_logout_view;
    class_tracker_manage_course_list: class_tracker_manage_course_list;
    class_tracker_add_classes: class_tracker_add_classes;
    class_tracker_view_class_alerts: class_tracker_view_class_alerts;
    class_tracker_get_schools: class_tracker_get_schools;
    class_tracker_get_subjects: class_tracker_get_subjects;
    class_tracker_get_course_sections: class_tracker_get_course_sections;
    class_tracker_refresh_available_terms: class_tracker_refresh_available_terms;
    class_tracker_refresh_semester_data: class_tracker_refresh_semester_data;
    class_tracker_fetch_new_semester_course_sections: class_tracker_fetch_new_semester_course_sections;
    class_tracker_get_recipient_form: class_tracker_get_recipient_form;
    class_tracker_update_recipient: class_tracker_update_recipient;
    class_tracker_add_watched_section: class_tracker_add_watched_section;
    class_tracker_remove_watched_section: class_tracker_remove_watched_section;
    queues_home: queues_home;
    queues_home_json: queues_home_json;
    queue_workers: queue_workers;
    queue_registry_jobs: queue_registry_jobs;
    queue_registry_action: queue_registry_action;
    queue_confirm_job_action: queue_confirm_job_action;
    queue_job_actions: queue_job_actions;
    workers_home: workers_home;
    worker_details: worker_details;
    job_details: job_details;
    job_detail_action: job_detail_action;
    discord_tracker_login: discord_tracker_login;
    discord_tracker_login_success: discord_tracker_login_success;
    discord_tracker_profile: discord_tracker_profile;
    discord_tracker_welcome: discord_tracker_welcome;
    discord_tracker_explore_all_listings: discord_tracker_explore_all_listings;
    discord_tracker_unapproved_invites: discord_tracker_unapproved_invites;
    discord_tracker_referral_management: discord_tracker_referral_management;
    discord_tracker_referral_redeem: discord_tracker_referral_redeem;
    discord_tracker_select_school: discord_tracker_select_school;
    discord_tracker_server_invites: discord_tracker_server_invites;
    discord_tracker_validate_discord_invite: discord_tracker_validate_discord_invite;
    discord_tracker_submit_invite: discord_tracker_submit_invite;
    discord_tracker_get_subjects: discord_tracker_get_subjects;
    discord_tracker_get_courses: discord_tracker_get_courses;
    discord_tracker_get_instructors: discord_tracker_get_instructors;
    discord_tracker_track_invite_usage: discord_tracker_track_invite_usage;
    discord_tracker_approve_invite: discord_tracker_approve_invite;
    discord_tracker_reject_invite: discord_tracker_reject_invite;
    discord_tracker_get_all_subjects: discord_tracker_get_all_subjects;
    discord_tracker_get_all_courses: discord_tracker_get_all_courses;
    __reactivated_do_not_use: __reactivated_do_not_use;
    __reactivated_do_not_use_args: __reactivated_do_not_use_args;
}

interface index {
    name: 'index';
    args: index_args;
}

interface index_args {
}

interface account_login {
    name: 'account_login';
    args: account_login_args;
}

interface account_login_args {
}

interface account_logout {
    name: 'account_logout';
    args: account_logout_args;
}

interface account_logout_args {
}

interface account_inactive {
    name: 'account_inactive';
    args: account_inactive_args;
}

interface account_inactive_args {
}

interface account_signup {
    name: 'account_signup';
    args: account_signup_args;
}

interface account_signup_args {
}

interface account_reauthenticate {
    name: 'account_reauthenticate';
    args: account_reauthenticate_args;
}

interface account_reauthenticate_args {
}

interface account_email {
    name: 'account_email';
    args: account_email_args;
}

interface account_email_args {
}

interface account_email_verification_sent {
    name: 'account_email_verification_sent';
    args: account_email_verification_sent_args;
}

interface account_email_verification_sent_args {
}

interface account_change_password {
    name: 'account_change_password';
    args: account_change_password_args;
}

interface account_change_password_args {
}

interface account_set_password {
    name: 'account_set_password';
    args: account_set_password_args;
}

interface account_set_password_args {
}

interface account_reset_password {
    name: 'account_reset_password';
    args: account_reset_password_args;
}

interface account_reset_password_args {
}

interface account_confirm_login_code {
    name: 'account_confirm_login_code';
    args: account_confirm_login_code_args;
}

interface account_confirm_login_code_args {
}

interface account_reset_password_from_key_done {
    name: 'account_reset_password_from_key_done';
    args: account_reset_password_from_key_done_args;
}

interface account_reset_password_from_key_done_args {
}

interface account_reset_password_done {
    name: 'account_reset_password_done';
    args: account_reset_password_done_args;
}

interface account_reset_password_done_args {
}

interface socialaccount_login_cancelled {
    name: 'socialaccount_login_cancelled';
    args: socialaccount_login_cancelled_args;
}

interface socialaccount_login_cancelled_args {
}

interface socialaccount_login_error {
    name: 'socialaccount_login_error';
    args: socialaccount_login_error_args;
}

interface socialaccount_login_error_args {
}

interface socialaccount_signup {
    name: 'socialaccount_signup';
    args: socialaccount_signup_args;
}

interface socialaccount_signup_args {
}

interface socialaccount_connections {
    name: 'socialaccount_connections';
    args: socialaccount_connections_args;
}

interface socialaccount_connections_args {
}

interface discord_login {
    name: 'discord_login';
    args: discord_login_args;
}

interface discord_login_args {
}

interface discord_callback {
    name: 'discord_callback';
    args: discord_callback_args;
}

interface discord_callback_args {
}

interface class_tracker_index {
    name: 'class_tracker:index';
    args: class_tracker_index_args;
}

interface class_tracker_index_args {
}

interface class_tracker_login_view {
    name: 'class_tracker:login_view';
    args: class_tracker_login_view_args;
}

interface class_tracker_login_view_args {
}

interface class_tracker_logout_view {
    name: 'class_tracker:logout_view';
    args: class_tracker_logout_view_args;
}

interface class_tracker_logout_view_args {
}

interface class_tracker_manage_course_list {
    name: 'class_tracker:manage_course_list';
    args: class_tracker_manage_course_list_args;
}

interface class_tracker_manage_course_list_args {
}

interface class_tracker_add_classes {
    name: 'class_tracker:add_classes';
    args: class_tracker_add_classes_args;
}

interface class_tracker_add_classes_args {
}

interface class_tracker_view_class_alerts {
    name: 'class_tracker:view_class_alerts';
    args: class_tracker_view_class_alerts_args;
}

interface class_tracker_view_class_alerts_args {
}

interface class_tracker_get_schools {
    name: 'class_tracker:get_schools';
    args: class_tracker_get_schools_args;
}

interface class_tracker_get_schools_args {
}

interface class_tracker_get_subjects {
    name: 'class_tracker:get_subjects';
    args: class_tracker_get_subjects_args;
}

interface class_tracker_get_subjects_args {
    school_id: number;
    term_id: number;
}

interface class_tracker_get_course_sections {
    name: 'class_tracker:get_course_sections';
    args: class_tracker_get_course_sections_args;
}

interface class_tracker_get_course_sections_args {
    term_id: number;
    subject_id: number;
}

interface class_tracker_refresh_available_terms {
    name: 'class_tracker:refresh_available_terms';
    args: class_tracker_refresh_available_terms_args;
}

interface class_tracker_refresh_available_terms_args {
}

interface class_tracker_refresh_semester_data {
    name: 'class_tracker:refresh_semester_data';
    args: class_tracker_refresh_semester_data_args;
}

interface class_tracker_refresh_semester_data_args {
    school_id: number;
    term_id: number;
}

interface class_tracker_fetch_new_semester_course_sections {
    name: 'class_tracker:fetch_new_semester_course_sections';
    args: class_tracker_fetch_new_semester_course_sections_args;
}

interface class_tracker_fetch_new_semester_course_sections_args {
    school_id: number;
    term_id: number;
    subject_id: number;
}

interface class_tracker_get_recipient_form {
    name: 'class_tracker:get_recipient_form';
    args: class_tracker_get_recipient_form_args;
}

interface class_tracker_get_recipient_form_args {
    recipient_id: number;
}

interface class_tracker_update_recipient {
    name: 'class_tracker:update_recipient';
    args: class_tracker_update_recipient_args;
}

interface class_tracker_update_recipient_args {
    recipient_id: number;
}

interface class_tracker_add_watched_section {
    name: 'class_tracker:add_watched_section';
    args: class_tracker_add_watched_section_args;
}

interface class_tracker_add_watched_section_args {
    recipient_id: number;
    section_id: number;
}

interface class_tracker_remove_watched_section {
    name: 'class_tracker:remove_watched_section';
    args: class_tracker_remove_watched_section_args;
}

interface class_tracker_remove_watched_section_args {
    recipient_id: number;
    section_id: number;
}

interface queues_home {
    name: 'queues_home';
    args: queues_home_args;
}

interface queues_home_args {
}

interface queues_home_json {
    name: 'queues_home_json';
    args: queues_home_json_args;
}

interface queues_home_json_args {
}

interface queue_workers {
    name: 'queue_workers';
    args: queue_workers_args;
}

interface queue_workers_args {
    queue_name: string;
}

interface queue_registry_jobs {
    name: 'queue_registry_jobs';
    args: queue_registry_jobs_args;
}

interface queue_registry_jobs_args {
    queue_name: string;
    registry_name: string;
}

interface queue_registry_action {
    name: 'queue_registry_action';
    args: queue_registry_action_args;
}

interface queue_registry_action_args {
    queue_name: string;
    registry_name: string;
    action: string;
}

interface queue_confirm_job_action {
    name: 'queue_confirm_job_action';
    args: queue_confirm_job_action_args;
}

interface queue_confirm_job_action_args {
    queue_name: string;
}

interface queue_job_actions {
    name: 'queue_job_actions';
    args: queue_job_actions_args;
}

interface queue_job_actions_args {
    queue_name: string;
}

interface workers_home {
    name: 'workers_home';
    args: workers_home_args;
}

interface workers_home_args {
}

interface worker_details {
    name: 'worker_details';
    args: worker_details_args;
}

interface worker_details_args {
    name: string;
}

interface job_details {
    name: 'job_details';
    args: job_details_args;
}

interface job_details_args {
    job_name: string;
}

interface job_detail_action {
    name: 'job_detail_action';
    args: job_detail_action_args;
}

interface job_detail_action_args {
    job_name: string;
    action: string;
}

interface discord_tracker_login {
    name: 'discord_tracker:login';
    args: discord_tracker_login_args;
}

interface discord_tracker_login_args {
}

interface discord_tracker_login_success {
    name: 'discord_tracker:login_success';
    args: discord_tracker_login_success_args;
}

interface discord_tracker_login_success_args {
}

interface discord_tracker_profile {
    name: 'discord_tracker:profile';
    args: discord_tracker_profile_args;
}

interface discord_tracker_profile_args {
}

interface discord_tracker_welcome {
    name: 'discord_tracker:welcome';
    args: discord_tracker_welcome_args;
}

interface discord_tracker_welcome_args {
}

interface discord_tracker_explore_all_listings {
    name: 'discord_tracker:explore_all_listings';
    args: discord_tracker_explore_all_listings_args;
}

interface discord_tracker_explore_all_listings_args {
}

interface discord_tracker_unapproved_invites {
    name: 'discord_tracker:unapproved_invites';
    args: discord_tracker_unapproved_invites_args;
}

interface discord_tracker_unapproved_invites_args {
}

interface discord_tracker_referral_management {
    name: 'discord_tracker:referral_management';
    args: discord_tracker_referral_management_args;
}

interface discord_tracker_referral_management_args {
}

interface discord_tracker_referral_redeem {
    name: 'discord_tracker:referral_redeem';
    args: discord_tracker_referral_redeem_args;
}

interface discord_tracker_referral_redeem_args {
    referral_code: string;
}

interface discord_tracker_select_school {
    name: 'discord_tracker:select_school';
    args: discord_tracker_select_school_args;
}

interface discord_tracker_select_school_args {
}

interface discord_tracker_server_invites {
    name: 'discord_tracker:server_invites';
    args: discord_tracker_server_invites_args;
}

interface discord_tracker_server_invites_args {
    server_id: number;
}

interface discord_tracker_validate_discord_invite {
    name: 'discord_tracker:validate_discord_invite';
    args: discord_tracker_validate_discord_invite_args;
}

interface discord_tracker_validate_discord_invite_args {
}

interface discord_tracker_submit_invite {
    name: 'discord_tracker:submit_invite';
    args: discord_tracker_submit_invite_args;
}

interface discord_tracker_submit_invite_args {
}

interface discord_tracker_get_subjects {
    name: 'discord_tracker:get_subjects';
    args: discord_tracker_get_subjects_args;
}

interface discord_tracker_get_subjects_args {
    school_id: number;
}

interface discord_tracker_get_courses {
    name: 'discord_tracker:get_courses';
    args: discord_tracker_get_courses_args;
}

interface discord_tracker_get_courses_args {
    school_id: number;
    subject_id: number;
}

interface discord_tracker_get_instructors {
    name: 'discord_tracker:get_instructors';
    args: discord_tracker_get_instructors_args;
}

interface discord_tracker_get_instructors_args {
    school_id: number;
    subject_id: number;
}

interface discord_tracker_track_invite_usage {
    name: 'discord_tracker:track_invite_usage';
    args: discord_tracker_track_invite_usage_args;
}

interface discord_tracker_track_invite_usage_args {
    invite_id: number;
}

interface discord_tracker_approve_invite {
    name: 'discord_tracker:approve_invite';
    args: discord_tracker_approve_invite_args;
}

interface discord_tracker_approve_invite_args {
    invite_id: number;
}

interface discord_tracker_reject_invite {
    name: 'discord_tracker:reject_invite';
    args: discord_tracker_reject_invite_args;
}

interface discord_tracker_reject_invite_args {
    invite_id: number;
}

interface discord_tracker_get_all_subjects {
    name: 'discord_tracker:get_all_subjects';
    args: discord_tracker_get_all_subjects_args;
}

interface discord_tracker_get_all_subjects_args {
}

interface discord_tracker_get_all_courses {
    name: 'discord_tracker:get_all_courses';
    args: discord_tracker_get_all_courses_args;
}

interface discord_tracker_get_all_courses_args {
    subject_id: number;
}

interface __reactivated_do_not_use {
    name: '__reactivated_do_not_use';
    args: __reactivated_do_not_use_args;
}

interface __reactivated_do_not_use_args {
}

interface __reactivated_do_not_use_args {
    name: '__reactivated_do_not_use_args';
    args: __reactivated_do_not_use_args_args;
}

interface __reactivated_do_not_use_args_args {
    _: string;
}

type WithArguments = |class_tracker_get_subjects|class_tracker_get_course_sections|class_tracker_refresh_semester_data|class_tracker_fetch_new_semester_course_sections|class_tracker_get_recipient_form|class_tracker_update_recipient|class_tracker_add_watched_section|class_tracker_remove_watched_section|queue_workers|queue_registry_jobs|queue_registry_action|queue_confirm_job_action|queue_job_actions|worker_details|job_details|job_detail_action|discord_tracker_referral_redeem|discord_tracker_server_invites|discord_tracker_get_subjects|discord_tracker_get_courses|discord_tracker_get_instructors|discord_tracker_track_invite_usage|discord_tracker_approve_invite|discord_tracker_reject_invite|discord_tracker_get_all_courses|__reactivated_do_not_use_args;
type WithoutArguments = |index|account_login|account_logout|account_inactive|account_signup|account_reauthenticate|account_email|account_email_verification_sent|account_change_password|account_set_password|account_reset_password|account_confirm_login_code|account_reset_password_from_key_done|account_reset_password_done|socialaccount_login_cancelled|socialaccount_login_error|socialaccount_signup|socialaccount_connections|discord_login|discord_callback|class_tracker_index|class_tracker_login_view|class_tracker_logout_view|class_tracker_manage_course_list|class_tracker_add_classes|class_tracker_view_class_alerts|class_tracker_get_schools|class_tracker_refresh_available_terms|queues_home|queues_home_json|workers_home|discord_tracker_login|discord_tracker_login_success|discord_tracker_profile|discord_tracker_welcome|discord_tracker_explore_all_listings|discord_tracker_unapproved_invites|discord_tracker_referral_management|discord_tracker_select_school|discord_tracker_validate_discord_invite|discord_tracker_submit_invite|discord_tracker_get_all_subjects|__reactivated_do_not_use;


    type All = WithArguments|WithoutArguments;
    export function reverse<T extends WithoutArguments['name']>(name: T): string;
    export function reverse<T extends WithArguments['name']>(name: T, args: Extract<WithArguments, {name: T}>['args']): string;
    export function reverse<T extends All['name']>(name: T, args?: Extract<WithArguments, {name: T}>['args']): string {
        let route = urls[name].route;

        if (args != null) {
            for (const token of Object.keys(args)) {
                route = route.replace(new RegExp('<(.+?:)' + token + '>'), (args as any)[token]);
            }
        }
        return route;
    }
